/** @file Clamps a number into [lo, hi]. */
import { invariant } from '@pose2d/std/invariant';

/** Returns v limited to the closed range [lo, hi]. */
export function clamp(v: number, lo: number, hi: number): number {
  invariant(lo <= hi, 'clamp: lo must be <= hi');
  return v < lo ? lo : v > hi ? hi : v;
}
